import { ButtonProps, CircularProgress } from "@mui/material";
import React, { forwardRef } from "react";

import { useMaterialUIController } from "@/contexts/mui-context";

import MDButtonRoot from "./root";

export interface MDButtonProps extends Omit<ButtonProps, "color" | "variant"> {
  size?: "small" | "medium" | "large";
  variant?: "text" | "contained" | "outlined" | "gradient";
  color?:
    | "white"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark";
  circular?: boolean;
  iconOnly?: boolean;
  children: React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
}

// eslint-disable-next-line react/display-name
export const MDButton = forwardRef<HTMLButtonElement, MDButtonProps>(
  (
    {
      color = "white",
      variant = "contained",
      size = "medium",
      circular = false,
      iconOnly = false,
      children,
      isLoading = false,
      disabled = false,
      ...rest
    },
    ref
  ) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const progressSize = size === "small" ? 10 : size === "large" ? 22 : 16;

    return (
      <MDButtonRoot
        {...rest}
        ref={ref}
        color="primary"
        variant={variant === "gradient" ? "contained" : variant}
        size={size}
        disabled={disabled || !!isLoading}
        ownerState={{ color, variant, size, circular, iconOnly, darkMode }}
        isLoading={isLoading}
      >
        {isLoading ? <CircularProgress size={progressSize} color="inherit" /> : children}
      </MDButtonRoot>
    );
  }
);
